import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'

import Pagination from '../utils/Pagination'
import { FaPencilAlt, FaTrash } from 'react-icons/fa'

import { useStateContext } from '../../state/context'
import { setCurrentLaboratoryData } from '../../state/actions/pharmacist.actions'

const PharmacistLabInvestigationSamplesTable = ({ data }) => {
    const dispatch = useDispatch()

    const { modals, setModals } = useStateContext()

    const [showTable, setShowTable] = useState(false)
    const [currentData, setCurrentData] = useState([])


    return (
        <div className="flex justify-between items-center w-full">
            <div
                className="flex flex-col w-full cursor-pointer"
            >
                <div className="">
                    <Fragment>
                        <div
                            className="flex justify-start items-center space-x-4 bg-gray-200 border-2 border-gray-200 p-1"
                            onClick={() => setShowTable(!showTable)}
                        >
                            <h4 className="text-dark-blue text-[14px] font-bold">
                                Investigation Samples
                            </h4>
                            {/* <CgPill className="text-dark-blue" size={20} /> */}
                        </div>
                        {showTable && (
                            <table className="border-b border-l border-r rounded w-full cursor-default">
                                <thead className="">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="text-sm font-medium text-gray-900 px-4 py-4 text-left"
                                        >
                                            S/N
                                        </th>
                                        <th
                                            scope="col"
                                            className="text-sm font-medium text-gray-900 py-4 text-left"
                                        >
                                            Title
                                        </th>
                                        <th
                                            scope="col"
                                            className="text-sm font-medium text-gray-900 py-4 text-left"
                                        >
                                            Investigation Category
                                        </th>
                                        <th
                                            scope="col"
                                            className="text-sm font-medium text-gray-900 py-4 text-left"
                                        >

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData?.map((category, index) => (
                                        <tr key={`${category.id}`}>
                                            <td className="px-4 py-2 whitespace-nowrap text-[12px] font-medium text-gray-900">
                                                {index + 1}
                                            </td>
                                            <td className="text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                                {category.sample_type}
                                            </td>
                                            <td className="text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                                {category?.investigations_category?.title}
                                            </td>
                                            <td className="flex space-x-4 text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                                <FaPencilAlt
                                                    size={20}
                                                    className='text-green-600 cursor-pointer'
                                                    onClick={() => {
                                                        dispatch(setCurrentLaboratoryData({ data: category }))
                                                        setModals({ ...modals, showPharmacistUpdateInvestigationSampleModal: !modals.showPharmacistUpdateInvestigationSampleModal })
                                                    }}
                                                />
                                                <FaTrash
                                                    size={20}
                                                    className="text-orange-400 cursor-pointer"
                                                    onClick={() => {
                                                        dispatch(setCurrentLaboratoryData({ data: category }))
                                                        setModals({ ...modals, showPharmacistDeleteInvestigationSampleModal: !modals.showPharmacistDeleteInvestigationSampleModal })
                                                    }}
                                                />
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <Pagination
                            data={data}
                            currentData={currentData}
                            setCurrentData={setCurrentData}
                        />
                    </Fragment>
                </div>
            </div>
        </div >
    )
}

export default PharmacistLabInvestigationSamplesTable
